"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCounter = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("../Icon");
const Button_1 = require("../Button");
exports.SmCounter = (0, react_1.forwardRef)((_a, ref) => {
    var { id, min = 0, max = 99, step = 1, label, srOnly, increaseIcon = react_1.default.createElement(Icon_1.SmIcon, { name: "add" }), increaseIconTitle = 'Aumentar valor', decreaseIcon = react_1.default.createElement(Icon_1.SmIcon, { name: "remove" }), decreaseIconTitle = 'Diminuir valor', className } = _a, props = __rest(_a, ["id", "min", "max", "step", "label", "srOnly", "increaseIcon", "increaseIconTitle", "decreaseIcon", "decreaseIconTitle", "className"]);
    const [value, setValue] = (0, react_1.useState)(props.value || 0);
    const fieldClassName = (0, classnames_1.default)('c-field -search', {
        '-disabled': props.disabled,
        className,
    });
    const fieldLabelClassName = (0, classnames_1.default)('c-field__label', {
        '-hidden': srOnly,
    });
    const controlClassName = 'c-control -search -number';
    const buttonClassName = 'c-control__iconnedBtn';
    const isNumber = (text) => {
        return /^-?\d+$/g.test(text);
    };
    const handleValueUpdate = (operation) => {
        const currentValue = isNumber(value) ? Number(value) : value;
        if (typeof currentValue === 'number') {
            if (operation === 'sub') {
                let newValue = currentValue - step;
                if (currentValue < min || newValue < min)
                    newValue = min;
                else if (currentValue > max)
                    newValue = max;
                setValue(newValue);
            }
            else if (operation === 'add') {
                let newValue = currentValue + step;
                if (currentValue > max || newValue > max)
                    newValue = max;
                else if (currentValue < min)
                    newValue = min;
                setValue(newValue);
            }
        }
    };
    return (react_1.default.createElement("div", { className: fieldClassName },
        react_1.default.createElement("label", { className: fieldLabelClassName, htmlFor: id }, label),
        react_1.default.createElement("div", { className: controlClassName },
            react_1.default.createElement("input", Object.assign({}, props, { className: "c-control__input", id: id, ref: ref, type: "number", min: min, max: max, value: value, disabled: props.disabled, onChange: (e) => setValue(e.target.value) })),
            react_1.default.createElement(Button_1.SmButton, { className: buttonClassName, type: "button", icon: decreaseIcon, disabled: props.disabled || value === min, isUnstyled: true, title: decreaseIconTitle, onClick: (e) => {
                    handleValueUpdate('sub');
                } }),
            react_1.default.createElement(Button_1.SmButton, { className: buttonClassName, icon: increaseIcon, type: "button", disabled: props.disabled || value === max, isUnstyled: true, title: increaseIconTitle, onClick: (e) => {
                    handleValueUpdate('add');
                } }))));
});
//# sourceMappingURL=index.js.map